import React from "react";
/** @jsx jsx */
import { css, jsx } from "@emotion/core";
import * as utilities from "./utilities";
import * as globals from "../globals";
import Masonry from "react-masonry-component";
import InfiniteScroll from "react-infinite-scroller";

import ArticleCard from "../ArticleCard";

export default class ArticleGrid extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      articles: [],
      more: true,
    };
    this.masonryProps = {
      itemSelector: ".grid-item",
      stamp: ".stamp",
    };
    this.getPosts = this.getPosts.bind(this);
  }

  getPosts(page) {
    fetch(
      `https://wp.dailybruin.com/wp-json/wp/v2/posts?_embed&tags=${this.props.tagID}+22993&page=${page}`
    )
      .then((response) => response.json())
      .then(
        (json) => {
          if (json.data == undefined) {
            this.setState({
              articles: this.state.articles.concat(json),
            });
          } else {
            this.setState({
              more: false,
            });
          }
        },
        (error) => {
          this.setState({
            more: false,
          });
        }
      )
      .catch((err) =>
        this.setState({
          more: false,
        })
      );
  }

  render() {
    let rendered = utilities.buildArticleCards(this.state.articles);
    return (
      <InfiniteScroll
        pageStart={0}
        loadMore={this.getPosts}
        hasMore={this.state.more}
        useWindow={false}
        loader={
          <p style={{ color: "#404040", textAlign: "center" }}>loading...</p>
        }
      >
        <div
          css={css`
            max-width: 624px;
            margin: auto;
          `}
        >
          <div
            css={css`
              padding: 6px;
            `}
          >
            <div
              css={css`
                ${globals.card}
                width: 100%;
                background-color: #2e2e2e;
                color: #fff;
                font-size: 18px;
                text-align: center;
                font-weight: bold;
              `}
            >
              Featured Content:
            </div>
          </div>
          <div
            css={css`
              padding: 6px;
            `}
          >
            <ArticleCard
              displayType="horz"
              headline="Unfinished Stories"
              excerpt="This new normal has not been easy. The COVID-19 pandemic has uprooted students’ everyday lives as they once knew them. Read how the novel coronavirus pandemic has affected students’ lives, and share your story on our interactive board."
              href="https://covidstories.dailybruin.com/"
              as="https://covidstories.dailybruin.com/"
              date={new Date("April 13, 2020 16:24:00")}
              authors={[
                {
                  name: "Daily Bruin Online",
                },
              ]}
              category={{
                name: "INTERACTIVES",
              }}
              imageurl="https://i.imgur.com/QzpQlAL.jpg"
              caption=""
            />
          </div>
        </div>
        <Masonry
          ref={function (c) {
            this.masonry = this.masonry || c.masonry;
          }.bind(this)}
          className={"grid"} // default ''
          options={this.masonryProps} // default {}
          disableImagesLoaded={false} // default false
          updateOnEachImageLoad={false} // default false and works only if disableImagesLoaded is false
          css={css`
            max-width: 624px;
            margin: auto;
            .grid-item {
              padding: 6px;
            }
            .grid-sizer,
            .grid-item {
              width: 50%;
            }
            ${globals.tablet} {
              .grid-sizer,
              .grid-item {
                width: 100%;
              }
            }
            ${globals.phone} {
              .grid-sizer,
              .grid-item {
                width: 100%;
              }
            }
          `}
        >
          <div className="grid-sizer"></div>
          <div
            css={css`
              padding: 6px;
              width: 50%;

              ${globals.tablet} {
                width: 100%;
              }
            `}
          >
            <div
              className="stamp"
              css={css`
                ${globals.card}
                background-color: #2e2e2e;
                color: #fff;
                font-size: 18px;
                text-align: center;
                font-weight: bold;
                margin-bottom: 6px;
              `}
            >
              Read all our latest stories here:
            </div>
          </div>
          {rendered}
        </Masonry>
        {!this.state.more ? (
          <p style={{ color: "#404040", textAlign: "center" }}>
            no more articles!
          </p>
        ) : (
          <span></span>
        )}
      </InfiniteScroll>
    );
  }
}
